export enum WithDrawActionTypes {
  API_RESPONSE_SUCCESS = "@@withdraw/API_RESPONSE_SUCCESS",
  API_RESPONSE_ERROR = "@@withdraw/API_RESPONSE_ERROR",

  GET_DATA = "@@withdraw/GET_DATA",
  WITHDRAW_STATUS = "@@withdraw/WITHDRAW_STATUS",
}
